// @flow strict
import React from 'react';
import classNames from 'classnames/bind';
import { Link } from 'gatsby';
import PageNumbers from './PageNumbers';
import { PAGINATION } from '../../constants';
import styles from './Pagination.module.scss';

type Props = {
  prevPagePath: string,
  nextPagePath: string,
  hasNextPage: boolean,
  hasPrevPage: boolean,
  numPages: number,
  currentPage: number,
  paginationSlug: string
};

const cx = classNames.bind(styles);

let Pagination = ({
  prevPagePath,
  nextPagePath,
  hasNextPage,
  hasPrevPage,
  numPages,
  currentPage,
  paginationSlug
}: Props) => {

  // TODO: why can't I get the data from page context!
  // console.log("numPages", numPages);
  // numPages = numPages || 10;
  // paginationSlug = paginationSlug || 'page';

  const prevClassName = cx({
    'pagination__prev-link': true,
    'pagination__prev-link--disable': !hasPrevPage
  });

  const nextClassName = cx({
    'pagination__next-link': true,
    'pagination__next-link--disable': !hasNextPage
  });

  return (
    <div className={styles['pagination']}>
      <div className={styles['pagination__prev']}>
        <Link rel="prev" to={hasPrevPage ? prevPagePath : '/'} className={prevClassName}>{PAGINATION.PREV_PAGE}</Link>
      </div>
      {numPages > 1 && (
        <PageNumbers
          numPages={numPages}
          currentPage={currentPage}
          paginationSlug={paginationSlug}
        >
        </PageNumbers>
      )}
      <div className={styles['pagination__next']}>
        <Link rel="next" to={hasNextPage ? nextPagePath : '/'} className={nextClassName}>{PAGINATION.NEXT_PAGE}</Link>
      </div>
    </div>
  );
};

export default Pagination;
